export const SET_FACETS_PAGINATION_MODE = 'SET_FACETS_PAGINATION_MODE'
export const SHOW_LAYOUT_NAVIGATION = 'SHOW_LAYOUT_NAVIGATION'
export const HIDE_LAYOUT_NAVIGATION = 'HIDE_LAYOUT_NAVIGATION'
export const LAYOUT_TOGGLE_FULL_SCREEN_OVERLAY = 'LAYOUT_TOGGLE_FULL_SCREEN_OVERLAY'
export const SET_LAYOUT_PAGE_ID = 'SET_LAYOUT_PAGE_ID'
export const SET_PAGE_LEFT = 'SET_PAGE_LEFT'
export const PAGE_RENDER_LEFT = 'PAGE_RENDER_LEFT'
export const SET_PAGE_VIEW = 'SET_PAGE_VIEW'
export const SET_PAGE_OVERLAY = 'SET_PAGE_OVERLAY'
export const SET_PAGE_PARAMETERS = 'SET_PAGE_PARAMETERS'
export const SET_IS_MOUSE_ABILITY_OPEN = 'SET_IS_MOUSE_ABILITY_OPEN'
export const SET_WINDOW_HEIGHT = 'SET_WINDOW_HEIGHT'
export const SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH'
export const SET_DEVICE_TYPE = 'SET_DEVICE_TYPE'
export const SET_BROWSER_IS_IE = 'SET_BROWSER_IS_IE'
export const SET_BROWSER_IS_IOS = 'SET_BROWSER_IS_IOS'
export const LAYOUT_WRAPPER_SET_URL = 'SET_LAYOUT_WRAPPER_URL'
export const SET_LAYOUT_FLAVOUR = 'SET_LAYOUT_FLAVOUR'
export const LAYOUT_WRAPPER_SET_BOTTLE_LINK = 'LAYOUT_WRAPPER_SET_BOTTLE_LINK'
export const LAYOUT_WRAPPER_SET_PAGE_DATA = 'LAYOUT_WRAPPER_SET_PAGE_DATA'
export const SET_LAYOUT_CONTROLLER = 'SET_LAYOUT_CONTROLLER'
export const SET_LAYOUT_BROWSER = 'SET_LAYOUT_BROWSER'
export const SET_LAYOUT_IS_TOUCH_DEVICE = 'SET_LAYOUT_IS_TOUCH_DEVICE'
export const SET_LAYOUT_HEADER_HEIGHT = 'SET_LAYOUT_HEADER_HEIGHT'
export const TEXT_EDITOR_SET_SELECTION_FUNCTION = 'TEXT_EDITOR_SET_SELECTION_FUNCTION'
export const LEGISLATION_REFERENCE_SET_HIGHLIGHTED = 'LEGISLATION_REFERENCE_SET_HIGHLIGHTED'
export const SET_PRECEDENTS_CONTENT_ENTER_IF_EMPTY = 'SET_PRECEDENTS_CONTENT_ENTER_IF_EMPTY'
export const SET_PRECEDENTS_EXPANDED_SECTION = 'SET_PRECEDENTS_EXPANDED_SECTION'
export const SET_PRECEDENT_ADMIN_IS_UPDATE_MODE = 'SET_PRECEDENT_ADMIN_IS_UPDATE_MODE'
export const SET_PRECEDENTS_VIEW = 'SET_PRECEDENTS_VIEW'
export const SET_PRECEDENT_ID = 'SET_PRECEDENT_PRECEDENT_ID'
export const SET_PRECEDENT_SECTION_ID = 'SET_PRECEDENT_SECTION_ID'
export const SET_PRECEDENT_ADMIN_FILES = 'SET_PRECEDENT_ADMIN_FILES'
export const SET_PRECEDENT_ADMIN_FILE_NAME = 'SET_PRECEDENT_ADMIN_FILE_NAME'
export const SET_PRECEDENT_ADMIN_FILE_SELECTED = 'SET_PRECEDENT_ADMIN_FILE_SELECTED'
export const SET_PRECEDENT_ADMIN_FILE_DESCRIPTION = 'SET_PRECEDENT_ADMIN_FILE_DESCRIPTION'
export const SET_PRECEDENT_ADMIN_PARENTS = 'SET_PRECEDENT_ADMIN_PARENTS'
export const SET_PRECEDENT_ADMIN_PARENT_ID = 'SET_PRECEDENT_ADMIN_PARENT_ID'
export const SET_PRECEDENT_ADMIN_POSITION = 'SET_PRECEDENT_ADMIN_POSITION'
export const SET_PRECEDENT_ADMIN_TITLE = 'SET_PRECEDENT_ADMIN_TITLE'
export const SET_PRECEDENT_ADMIN_TIERS = 'SET_PRECEDENT_ADMIN_TIERS'
export const SET_PRECEDENT_ADMIN_CHECKBOXES = 'SET_PRECEDENT_ADMIN_CHECKBOXES'
export const SET_PRECEDENT_ADMIN_PLACE_AT = 'SET_PRECEDENT_ADMIN_PLACE_AT'
export const SET_PRECEDENT_TILED_MENU = 'SET_PRECEDENT_TILED_MENU'
export const SET_LEGISLATION_WRAPPER_EDIT_MODE = 'SET_LEGISLATION_WRAPPER_EDIT_MODE'
export const SET_LEGISLATION_WRAPPER_ADMIN_BUTTON = 'SET_LEGISLATION_WRAPPER_ADMIN_BUTTON'
export const SET_LEGISLATION_WRAPPER_CONTENT_EDITOR = 'SET_LEGISLATION_WRAPPER_CONTENT_EDITOR'
export const SET_LEGISLATION_WRAPPER_TITLE_EDITOR = 'SET_LEGISLATION_WRAPPER_TITLE_EDITOR'
export const SET_LEGISLATION_FOLDERS = 'SET_LEGISLATION_FOLDERS'
export const SET_LEGISLATION_FOLDERS_MAP = 'SET_LEGISLATION_FOLDERS_MAP'
export const SET_LEGISLATION_ACT_ID_MAP = 'SET_LEGISLATION_ACT_ID_MAP'
export const SET_LEGISLATION_ACT = 'SET_LEGISLATION_ACT'
export const SET_LEGISLATION_PATH = 'SET_LEGISLATION_PATH'
export const SET_LEGISLATION_ACT_NODES = 'SET_LEGISLATION_ACT_NODES'
export const SET_LEGISLATION_ACT_HOVER_ICON_MAP = 'SET_LEGISLATION_ACT_HOVER_ICON_MAP'
export const SET_LEGISLATION_ACTS = 'SET_LEGISLATION_ACTS'
export const SET_QA_SECTION_ID = 'SET_QA_SECTION_ID'
export const SET_QA_SECTIONS = 'SET_QA_SECTIONS'
export const SET_QA_ROOT_SECTIONS = 'SET_QA_ROOT_SECTIONS'
export const SET_QA_SECTIONS_MAP = 'SET_QA_SECTIONS_MAP'
export const SET_QA_PICKED_SECTION = 'SET_QA_PICKED_SECTION'
export const SET_QA_NODE_MAP = 'SET_QA_NODE_MAP'
export const SET_QA_COMMENT_MAP = 'SET_QA_COMMENT_MAP'
export const SET_HOMEPAGE_ARTICLES = 'SET_HOMEPAGE_ARTICLES'
export const SET_USER_DETAILS = 'SET_USER_DETAILS'
export const SET_USER_IS_LOGGED = 'SET_USER_IS_LOGGED'
export const SET_USER_ROLES = 'SET_USER_ROLES'
export const SET_USER_IS_ADMIN = 'SET_USER_IS_ADMIN'
export const SET_USER_IS_CORE = 'SET_USER_IS_CORE'
export const SET_USER_IS_LIMITED_ACCESS = 'SET_USER_IS_LIMITED_ACCESS'
export const SET_USER_IS_CLARILIS = 'SET_USER_IS_CLARILIS'
export const SET_USER_IS_DOCDRAFTER = 'SET_USER_IS_DOCDRAFTER'
export const SET_USER_ENCRYPTION_KEYS_LOADED = 'SET_USER_ENCRYPTION_KEYS_LOADED'
export const SET_ALL_USERS = 'SET_ALL_USERS'
export const SET_USER_URN = 'SET_USER_URN'
export const SET_ACCORDION_EXPANDED_NODE_ID = 'SET_ACCORDION_EXPANDED_NODE_ID'
export const SET_ACCORDION_EXPANDED_NODE_TITLE = 'SET_ACCORDION_EXPANDED_NODE_TITLE'
export const SET_ACCORDION_HIGHLIGHT = 'SET_ACCORDION_HIGHLIGHT'
export const SET_ACCORDION_GROUP = 'SET_ACCORDION_GROUP'
export const SET_ACCORDION_EVENT_CATEGORY = 'SET_ACCORDION_EVENT_CATEGORY'
export const SET_ACCORDION_HAS_EXPAND_CALLBACK = 'SET_ACCORDION_HAS_EXPAND_CALLBACK'
export const SET_ACCORDION_BREADCRUMB_CLICKED = 'SET_ACCORDION_BREADCRUMB_CLICKED'
export const SET_TILED_MENU_PAGE_ID = 'SET_TILED_MENU_PAGE_ID'
export const SET_IS_TILED_MENU = 'SET_IS_TILED_MENU'
export const SET_TILED_MENU_IS_LOADED = 'SET_TILED_MENU_IS_LOADED'
export const SET_ACCORDION_IS_LOADED = 'SET_ACCORDION_IS_LOADED'
export const SET_DASHBOARD_IS_LOADED = 'SET_DASHBOARD_IS_LOADED'
export const SET_HOMEPAGE_STORIES_IS_LOADED = 'SET_HOMEPAGE_STORIES_IS_LOADED'
export const SET_HOMEPAGE_FC_UPDATES_IS_LOADED = 'SET_HOMEPAGE_FC_UPDATES_IS_LOADED'
export const SET_SEARCH_RESULTS_LOADED = 'SET_SEARCH_RESULTS_LOADED'
export const SET_ANNOTATIONS_LOADED = 'SET_ANNOTATIONS_LOADED'
export const SET_HIDE_OVERRIDE = 'SET_HIDE_OVERRIDE'
export const SET_ACCORDION_CAN_ACCESS = 'SET_ACCORDION_CAN_ACCESS'
export const SET_ACCORDION_SECTION_ID = 'SET_ACCORDION_SECTION_ID'
export const SET_ACCORDION_URL_NODE = 'SET_ACCORDION_URL_NODE'
export const SET_SELECTED_DEALS = 'SET_SELECTED_DEALS'
export const SET_SELECTED_DEAL_TYPE = 'SET_SELECTED_DEAL_TYPE'
export const SET_ACCORDION_COMMENT_CONTROLS_ACTIVE_ID = 'SET_ACCORDION_COMMENT_CONTROLS_ACTIVE_ID'
export const PAUSE_NEWS_TICKER = 'PAUSE_NEWS_TICKER'
export const RESUME_NEWS_TICKER = 'RESUME_NEWS_TICKER'
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS'
export const SET_SEARCH_PAGE_LIMIT = 'SET_SEARCH_PAGE_LIMIT'
export const SET_PAGINATION_PAGE_NUMBER = 'SET_PAGINATION_PAGE_NUMBER'
export const SET_SEARCH_PAGINATION_MODE = 'SET_SEARCH_PAGINATION_MODE'
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
export const SET_SEARCH_PHRASE = 'SET_SEARCH_PHRASE'
export const SET_CURRENT_SEARCH_PHRASE = 'SET_CURRENT_SEARCH_PHRASE'
export const SET_SEARCH_TYPE = 'SET_SEARCH_TYPE'
export const SET_CURRENT_SEARCH_TYPE = 'SET_CURRENT_SEARCH_TYPE'
export const SET_SEARCH_RESPONSE = 'SET_SEARCH_RESPONSE'
export const SET_SEARCH_TYPE_DISPLAY_NAME = 'SET_SEARCH_TYPE_DISPLAY_NAME'
export const SET_SEARCH_TYPE_CLASSES = 'SET_SEARCH_TYPE_CLASSES'
export const SET_SEARCH_HELPER_VISIBLE = 'SET_SEARCH_HELPER_VISIBLE'
export const SET_CMS_CTX = 'SET_CMS_CTX'
export const SET_SIGN_UP_MODAL_IS_OPEN = 'SET_SIGN_UP_MODAL_IS_OPEN'
export const SET_FREE_TRIAL_REQUEST_MODAL_IS_OPEN = 'SET_FREE_TRIAL_REQUEST_MODAL_IS_OPEN'
export const SET_USER_ROLES_MODAL_IS_OPEN = 'SET_USER_ROLES_MODAL_IS_OPEN'
export const SET_USER_ROLES_MODAL_IS_BASIC_MESSAGE = 'SET_USER_ROLES_MODAL_IS_BASIC_MESSAGE'
export const SET_ANNOTATIONS_COMMENTS_LOADED = 'SET_ANNOTATIONS_COMMENTS_LOADED'
export const SET_AOL_NAME = 'SET_AOL_NAME'
export const SET_AVAILABLE_AOL = 'SET_AVAILABLE_AOL'
export const SET_AOL_CONFIG_MAP = 'SET_AOL_CONFIG_MAP'
export const SET_AOL_HEADER_MENU = 'SET_AOL_HEADER_MENU'
export const SET_AOL_FOOTER_MENU = 'SET_AOL_FOOTER_MENU'
export const SET_AOL_SEARCH_MENU = 'SET_AOL_SEARCH_MENU'
export const SET_AOL_PAGE_RULES = 'SET_AOL_PAGE_RULES'
export const SET_AOL_CONFIG_LOADED = 'SET_AOL_CONFIG_LOADED'
export const SET_ANNOTATIONS_IS_COMMENTS_FILTERED = 'SET_ANNOTATIONS_IS_COMMENTS_FILTERED'
export const SET_FAQ_GROUP = 'SET_FAQ_GROUP'
export const SET_FAQ_GROUP_MAP = 'SET_FAQ_GROUP_MAP'
export const SET_FAQ_EXPANDED_NODE_IDS = 'SET_FAQ_EXPANDED_NODE_IDS'
export const SET_FAQ_SCROLL_TO_ID = 'SET_FAQ_SCROLL_TO_ID'
export const SET_SHOW_SIGN_UP_MODAL_ON_CLOSE = 'SET_SHOW_SIGN_UP_MODAL_ON_CLOSE'
export const SET_ACCESS_ROLES = 'SET_ACCESS_ROLES'
